import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { queryKeys } from '../../constants/EQueryKeysConstant'
import { Prp2boxApiGames } from '../../prp2boxApi'
import { CreateRpGamePayload } from '../../prp2boxApi/games'
import { useStore } from '../../stores'
import { WrapDrawerCreateForm } from '../index'
import RpGameFormBase from './base'
import { TRpGameFormData } from './schema'
import { useRpGameForm } from './useRpGameForm'

const RpGameFormCreate: FC = observer(() => {
  const queryClient = useQueryClient()
  const hookForm = useRpGameForm()
  const { drawerCRUDStore } = useStore()

  const createMutation = useMutation((payload: CreateRpGamePayload) => Prp2boxApiGames.create(payload), {
    onSuccess: async () => {
      toast.success('Игра успешно создана')
      await queryClient.invalidateQueries({
        queryKey: queryKeys.rpGames.base,
      })

      drawerCRUDStore.resetView()
    },
  })

  const handleSave = (data: TRpGameFormData) => {
    const {
      name,
      dealer: dealerId,
      player: playerId,
      limit: limitId,
      stand: standId,
      bonus: bonusId,
      payout: payoutId,
    } = data

    createMutation.mutate({
      name,
      dealerId,
      playerId,
      limitId,
      standId,
      bonusId,
      payoutId,
    })
  }

  return (
    <WrapDrawerCreateForm title="Создание новой игры" onSave={hookForm.handleSubmit(handleSave)}>
      <RpGameFormBase hookForm={hookForm} />
    </WrapDrawerCreateForm>
  )
})

export default RpGameFormCreate
